export default "__VITE_ASSET__3bda2107__"